import axios from 'axios'
import router from '@/router'

export default () => {
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
  if (sessionStorage.getItem('token')) {
    headers.Authorization = sessionStorage.getItem('token')
  }
  const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: false,
    headers
  })

  instance.interceptors.response.use(null, function(error) {
    // Only redirect to login on actual 401 Unauthorized responses
    // Don't redirect on network errors (CORS, timeout, etc.) as those aren't auth issues
    if (error.response && error.response.status === 401) {
      sessionStorage.removeItem('token')
      router.replace('/login')
    }
    return Promise.reject(error)
  })

  return instance
}